"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumDescription = void 0;
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
function enumDescription({ userFacingTitle, userFacingValue, values, order, }) {
    return {
        userFacingTitle,
        userFacingValue,
        validate(value) {
            if (typeof value !== 'string') {
                return new InvalidResult_1.default(`Not a string: ${value}`);
            }
            if (!values.includes(value)) {
                return new InvalidResult_1.default(`Not a valid ${userFacingTitle}: ${value}`);
            }
            return value;
        },
        values,
        order,
    };
}
exports.enumDescription = enumDescription;
